export enum GanttEventTypes {
  Kebab = 'kebab',
  Expand = 'expand',
  Name = 'name',
  Sort = 'sort',
  Bar = 'bar',
  Tooltip = 'tooltip',
  Unknown = 'unknown',
}

export enum GanttScaleUnits {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Year = 'year',
  Quarter = 'quarter',
}
